const getHeadingId = (id) => `${id}-label`;

export { getHeadingId };
